import React from "react"
import {UserDetails} from "components/backoffice/User/Details/UserDetails"
import {BackofficePage, BackofficePanel} from "components/backoffice/Layout/BackofficePage"

export const UserAddRoute = () => {

  return <BackofficePage
    className="user-add-route-container"
    eyebrow="Administration"
    title="Nouvel utilisateur"
    description="Autorisez une nouvelle adresse à accéder à la plateforme."
    icon="fa-user-plus"
  >
    <BackofficePanel title="Informations du compte" description="L'adresse e-mail servira d'identifiant." icon="fa-id-card">
      <UserDetails userId={null} open={true} />
    </BackofficePanel>
  </BackofficePage>
}
